type JSONValue = any;

const inflight = new Map<string, Promise<JSONValue>>();
const ready    = new Map<string, JSONValue>();

export function prefetchJSON(key: string, fetcher: () => Promise<JSONValue>) {
  if (ready.has(key) || inflight.has(key)) return;
  const p = fetcher().then(data => { ready.set(key, data); inflight.delete(key); return data; })
                     .catch(e => { inflight.delete(key); throw e; });
  inflight.set(key, p);
}

export function getPrefetched<T = any>(key: string): T | undefined {
  return ready.get(key) as T | undefined;
}

export async function ensureJSON<T = any>(key: string, fetcher: () => Promise<T>) {
  const cached = getPrefetched<T>(key);
  if (cached) return cached;
  if (!inflight.has(key)) prefetchJSON(key, fetcher);
  return inflight.get(key)! as Promise<T>;
}

export function clearCache(key: string) {
  ready.delete(key);
  inflight.delete(key);
}

export function clearAllCache() {
  ready.clear();
  inflight.clear();
}
